import axios from 'axios';

export type PublicStats = {
  gameCount: number;
  lessonCount: number;
};

const publicStatsClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL ?? '',
});

export async function fetchPublicStats(): Promise<PublicStats> {
  const { data } = await publicStatsClient.get<PublicStats>('/public/stats');
  return data;
}
